"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanupLocalTracks = exports.createCameraTrack = exports.clearLocalVideoTrack = exports.getLocalTracks = exports.getScreenTrack = exports.createScreenTrack = exports.createLocalTracks = exports.getAgoraClient = void 0;
const agora_rtc_sdk_ng_1 = __importDefault(require("agora-rtc-sdk-ng"));
let client = null;
let localAudioTrack = null;
let localVideoTrack = null;
let screenTrack = null;
const getAgoraClient = () => {
    if (!client) {
        client = agora_rtc_sdk_ng_1.default.createClient({ mode: 'rtc', codec: 'vp8' });
    }
    return client;
};
exports.getAgoraClient = getAgoraClient;
const createLocalTracks = async (audioConfig = { AEC: true, AGC: true, ANS: true }, videoConfig = { encoderConfig: '720p', optimizationMode: 'motion', video: false }) => {
    try {
        // Önce temizle
        if (!localAudioTrack) {
            localAudioTrack = await agora_rtc_sdk_ng_1.default.createMicrophoneAudioTrack(audioConfig);
        }
        // Sadece video istenmişse ve track yoksa oluştur
        if (videoConfig.video && !localVideoTrack) {
            localVideoTrack = await agora_rtc_sdk_ng_1.default.createCameraVideoTrack({
                encoderConfig: videoConfig.encoderConfig,
                optimizationMode: videoConfig.optimizationMode
            });
        }
        return { localAudioTrack, localVideoTrack };
    }
    catch (error) {
        console.error('[agoraClient] Track creation failed:', error);
        return { localAudioTrack, localVideoTrack: null };
    }
};
exports.createLocalTracks = createLocalTracks;
const createScreenTrack = async (config = { encoderConfig: '1080p_1' }) => {
    if (screenTrack) {
        screenTrack.close();
        screenTrack = null;
    }
    const result = await agora_rtc_sdk_ng_1.default.createScreenVideoTrack(config, 'disable');
    // createScreenVideoTrack with 'disable' always returns ILocalVideoTrack (not a tuple)
    screenTrack = result;
    return screenTrack;
};
exports.createScreenTrack = createScreenTrack;
const getScreenTrack = () => screenTrack;
exports.getScreenTrack = getScreenTrack;
const getLocalTracks = () => ({ localAudioTrack, localVideoTrack });
exports.getLocalTracks = getLocalTracks;
/** After manually closing localVideoTrack, call this to clear the module reference */
const clearLocalVideoTrack = () => { localVideoTrack = null; };
exports.clearLocalVideoTrack = clearLocalVideoTrack;
/** Create only the camera track (no audio). Returns null on failure (e.g. device busy). */
const createCameraTrack = async (config = {
    encoderConfig: '720p',
    optimizationMode: 'motion',
}) => {
    try {
        const track = await agora_rtc_sdk_ng_1.default.createCameraVideoTrack(config);
        localVideoTrack = track;
        return track;
    }
    catch (err) {
        console.warn('[agoraClient] Camera track creation failed:', err);
        return null;
    }
};
exports.createCameraTrack = createCameraTrack;
const cleanupLocalTracks = () => {
    if (localAudioTrack) {
        localAudioTrack.stop();
        localAudioTrack.close();
        localAudioTrack = null;
    }
    if (localVideoTrack) {
        localVideoTrack.stop();
        localVideoTrack.close();
        localVideoTrack = null;
    }
    if (screenTrack) {
        screenTrack.stop();
        screenTrack.close();
        screenTrack = null;
    }
    console.log('[agoraClient] All local tracks cleaned up');
};
exports.cleanupLocalTracks = cleanupLocalTracks;
